import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AbdaliModuleConfig, moduleConfigToken } from '../app.module';
import { AddressDto, AddressAreaDto, ApiResponse } from '../objects';
import { GenericAbsService, QueryParams } from '../utils/generic-abs-service';

@Injectable()
export class AddressService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    getAddressByUser(endpoint?: string, headers?: HttpHeaders) {
        const url = endpoint == null ? '/api/v1/address' : endpoint;
        return this.getAll(url, headers);
    }

    insert(endpoint: string = null, dto: AddressDto, headers?: HttpHeaders) {
        const url = endpoint == null ? '/api/v1/address' : endpoint;
        return this.post(url, dto, headers);
    }

    deleteAddress(endpoint: string = null, addressId: number, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/address' : endpoint;
        return this.delete(endpoint, addressId, headers);
    }

    getArea(endpoint: string = null, headers?: HttpHeaders) {
        endpoint = endpoint == null ? '/api/v1/address/area' : endpoint;
        return this.getAll(endpoint, headers);
    }

}
